import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FaturamentoComponent } from '../modules/dashboard/components/minha-conta/faturamento/faturamento.component';
import { ModalDetailComponent } from './components/modal-detail/modal-detail.component';
import { LinkShortenerService } from './services/link-shortener/link-shortener.service';
import {ClientNotificationService} from './services/client-notification/client-notification.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgxMaskDirective
  ],
  declarations: [
    FaturamentoComponent,
    ModalDetailComponent
  ],
  providers: [
    LinkShortenerService,
    ClientNotificationService,
    provideNgxMask()
  ],
  exports: [
    FaturamentoComponent,
    ModalDetailComponent
  ]
})
export class SharedModule { }
